module.exports = __webpack_public_path__ + "img/image-01.0f8ae1fe.jpeg";